<template>
  <!-- Render children to provide a render output -->
  <slot />
</template>

<script setup lang="ts">
import { inject, onBeforeUnmount, onMounted, useSlots } from 'vue';
import type { Slot } from 'vue';

const props = defineProps<{
  name?: string; // persistent id
  label?: string; // fallback label
}>();

const slots = useSlots();

type RegisterTab = (tab: { id?: string; header?: Slot; content?: Slot; label?: string }) => void;

type UnregisterTab = (id: string) => void;

const register = inject<RegisterTab>('persisted-tabs:register');
const unregister = inject<UnregisterTab>('persisted-tabs:unregister');

onMounted(() => {
  register?.({
    id: props.name,
    header: slots.header,
    content: slots.content ?? slots.default,
    label: props.label,
  });
});

onBeforeUnmount(() => {
  if (props.name) unregister?.(props.name);
});
</script>
